import React from "react";
import { Popup } from "semantic-ui-react";

const withPopup = (WrappedComponent) => {
  return function ({ popupProps, ...props }) {
    return <Popup trigger={<WrappedComponent {...props} />} {...popupProps} />;
  };
};

export default withPopup;
